import '../Assets/styles/form.css'
import React from 'react'

const form = () => {
  return (
    <>
        <div className="container-lg">
        <iframe className='formcontt' src="https://docs.google.com/forms/d/e/1FAIpQLSc-dabyoIMdyke4PbNW-txYq98B9gUfUjxh77kCi9knR8BSGw/viewform?embedded=true"  title='forr'>Loading…</iframe>
        </div>
    </>
  )
}

export default form